export default __webpack_public_path__ + "static/media/yelp-review-image.d1792543.png";